import { render, staticRenderFns } from "./SpeedAccusationSpeed.vue?vue&type=template&id=5613b5c0&"
import script from "./SpeedAccusationSpeed.vue?vue&type=script&lang=js&"
export * from "./SpeedAccusationSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports